<div class="form-content-item">
  <form [formGroup]="form" (keydown.enter)="$event.stopPropagation()">
    <div class="form-header-item">
      <div>
        <h2 *ngIf="currentItem?.displayName">{{ currentItem.displayName }} [{{ currentItem.code }}]</h2>
      </div>
      <div class="div-btns-top">
        <action-bar
          [showSave]="!isFormDisable()"
          [showAddToFavorites]="!favoriteId && currentItem && currentItem.resourceId"
          [showRemoveFromFavorites]="favoriteId"
          [showDuplicate]="!!currentItem?.canDuplicate"
          [showDelete]="!!currentItem?.resourceId && !isFormDisable()"
          (onSave)="clickSave(currentItem)"
          (onAddToFavorites)="addToFavorite(currentItem.resourceId!)"
          (onRemoveFromFavorites)="removeFromFavorite()"
          (onDuplicate)="onDplicate(currentItem.resourceId!)"
          (onDelete)="onDeleteDialog(currentItem.resourceId!)"></action-bar>
      </div>
    </div>
    <div>
      <div class="identification" [class]="{ 'disabled-form': isFormDisable() }">
        <h3 class="title-margin-top">{{ 'common_section_identification' | translate }}</h3>
        <mat-card>
          <mat-grid-list cols="10" rowHeight="60px" gutterSize="20px">
            <mat-grid-tile colspan="2">
              <mat-form-field>
                <mat-label color="accent">{{ 'common_field_code' | translate }}</mat-label>
                <input matInput formControlName="code" minlength="2" maxlength="10" required [readonly]="isFormDisable()" />
                <mat-error *ngIf="formCrls.code.invalid">{{ 'ref_error_code_required' | translate }}</mat-error>
              </mat-form-field>
            </mat-grid-tile>
            <mat-grid-tile colspan="3">
              <mat-form-field>
                <mat-label>{{ 'common_field_label' | translate }}</mat-label>
                <input matInput formControlName="displayName" required [readonly]="isFormDisable()" />
                <mat-error *ngIf="formCrls.displayName.invalid">{{ 'ref_error_label_required' | translate }}</mat-error>
              </mat-form-field>
            </mat-grid-tile>
            <mat-grid-tile colspan="3" *ngIf="currentItem?.resourceId">
              <mat-form-field>
                <mat-label>{{ 'common_field_owner' | translate }}</mat-label>
                <input matInput disabled [value]="formCrls.owner.value | resourceAuthor: currentItem" />
              </mat-form-field>
            </mat-grid-tile>
            <mat-grid-tile colspan="2" *ngIf="currentItem?.resourceId">
              <mat-form-field>
                <mat-label>{{ 'common_field_creator' | translate }}</mat-label>
                <input matInput disabled [value]="formCrls.creator.value | resourceAuthor: currentItem" />
              </mat-form-field>
            </mat-grid-tile>
          </mat-grid-list>
        </mat-card>
      </div>
      <div class="engin" [class]="{ 'disabled-form': isFormDisable() }">
        <div class="title title-margin-top">
          <h3>{{ 'engin_section' | translate }}</h3>
          <mat-card>
            <div class="row family">
              <div class="col-3">
                <mat-form-field>
                  <mat-label>{{ 'ref_field_family' | translate }}</mat-label>
                  <mat-select formControlName="familyId" required>
                    <mat-option *ngFor="let f of families" [value]="f.familyId"> {{ f.familyDisplayName }} [{{ f.familyCode }}] </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <mat-form-field>
                  <mat-label>{{ 'common_field_description' | translate }}</mat-label>
                  <textarea type="text" formControlName="description" rows="3" matInput [readonly]="isFormDisable()"></textarea>
                </mat-form-field>
              </div>
            </div>
          </mat-card>
        </div>
      </div>

      <div class="row">
        <div class="version col-6" *ngIf="currentItem.resourceId">
          <h3 class="title-margin-top" style="opacity: 0.8">{{ 'ref_section_db_version' | translate }}</h3>
          <mat-card>
            <div class="row">
              <div class="col-12">
                <mat-form-field>
                  <mat-label>{{ 'ref_field_choose_version' | translate }}</mat-label>
                  <mat-select [multiple]="false" formControlName="versionId" (selectionChange)="onVersionChange($event.value)">
                    <mat-option *ngFor="let p of dbVersions" [value]="p.versionId">
                      {{ p.versionName }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
          </mat-card>
        </div>

        <div class="version col-6">
          <h3 class="title-margin-top" style="opacity: 0.8">{{ 'engin_energy_consumed_title' | translate }}</h3>
          <mat-card>
            <div class="row">
              <div class="col-12">
                <mat-form-field>
                  <mat-label>{{ 'engin_energy_label' | translate }}</mat-label>
                  <mat-select [multiple]="false" formControlName="energyId" (selectionChange)="onEnergyChange($event.value)">
                    <mat-option [value]="EMPTY_GUID">{{ 'common_other_energy' | translate }}</mat-option>
                    <mat-option *ngFor="let p of energies" [value]="p.resourceId">
                      {{ p.displayName }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
          </mat-card>
        </div>
      </div>

      <div class="title title-margin-top" [class]="{ 'disabled-form': isFormDisable() }">
        <div class="row">
          <div class="col-6">
            <mat-card formGroupName="ceuCarburant">
              <div class="row">
                <h3 class="ceuTitle">{{ 'engin_section_carburant' | translate }}</h3>
                <div class="col-4">
                  <mat-form-field>
                    <mat-label>{{ 'ref_field_energy_mj' | translate }}</mat-label>
                    <input matInput type="number" formControlName="ceuCarburantEn" required [readonly]="isFormDisable()" />
                    <mat-error *ngIf="formCrls.ceuCarburant?.get('ceuCarburantEn')?.invalid">{{ 'engin_error_carburant_required' | translate }}</mat-error>
                  </mat-form-field>
                </div>
                <div class="col-4" [class.disabled-form]="!isAutreEnergie">
                  <mat-form-field>
                    <mat-label>{{ 'ref_field_co2_t' | translate }}</mat-label>
                    <input matInput type="number" formControlName="ceuCarburantCo" required [readonly]="isFormDisable() || !isAutreEnergie" (change)="onChangeValuesOtherCeu()" />
                  </mat-form-field>
                </div>
              </div>
            </mat-card>
          </div>
          <div class="col-6">
            <mat-card formGroupName="ceuTransfert">
              <div class="row">
                <h3 class="ceuTitle">{{ 'engin_section_transfert' | translate }}</h3>
                <div class="col-4">
                  <mat-form-field>
                    <mat-label>{{ 'ref_field_energy_mj' | translate }}</mat-label>
                    <input matInput type="number" formControlName="ceuTransfertEn" required [readonly]="isFormDisable()" />
                    <mat-error *ngIf="formCrls.ceuTransfert?.get('ceuTransfertEn')?.invalid">{{ 'engin_error_transfert_required' | translate }}</mat-error>
                  </mat-form-field>
                </div>
                <div class="col-4">
                  <mat-form-field>
                    <mat-label>{{ 'ref_field_co2_t' | translate }}</mat-label>
                    <input matInput type="number" formControlName="ceuTransfertCo" required [readonly]="isFormDisable()" />
                    <mat-error *ngIf="formCrls.ceuTransfert?.get('ceuTransfertCo')?.invalid">{{ 'engin_error_transfert_required' | translate }}</mat-error>
                  </mat-form-field>
                </div>
              </div>
            </mat-card>
          </div>
        </div>

        <div class="row" style="margin-top: 20px">
          <div class="col-6">
            <mat-card formGroupName="ceuFabrication">
              <div class="row">
                <h3 class="ceuTitle">{{ 'engin_section_fabrication' | translate }}</h3>
                <div class="col-4">
                  <mat-form-field>
                    <mat-label>{{ 'ref_field_energy_mj' | translate }}</mat-label>
                    <input matInput type="number" formControlName="ceuFabricationEn" required [readonly]="isFormDisable()" />
                    <mat-error *ngIf="formCrls.ceuFabrication?.get('ceuFabricationEn')?.invalid">{{ 'engin_error_fabrication_required' | translate }}</mat-error>
                  </mat-form-field>
                </div>
                <div class="col-4">
                  <mat-form-field>
                    <mat-label>{{ 'ref_field_co2_t' | translate }}</mat-label>
                    <input matInput type="number" formControlName="ceuFabricationCo" required [readonly]="isFormDisable()" />
                    <mat-error *ngIf="formCrls.ceuFabrication?.get('ceuFabricationCo')?.invalid">{{ 'engin_error_fabrication_required' | translate }}</mat-error>
                  </mat-form-field>
                </div>
              </div>
            </mat-card>
          </div>
          <div class="col-6">
            <mat-card formGroupName="ceuEntretien">
              <div class="row">
                <h3 class="ceuTitle">{{ 'engin_section_entretien' | translate }}</h3>
                <div class="col-4">
                  <mat-form-field>
                    <mat-label>{{ 'ref_field_energy_mj' | translate }}</mat-label>
                    <input matInput type="number" formControlName="ceuEntretienEn" required [readonly]="isFormDisable()" />
                    <mat-error *ngIf="formCrls.ceuEntretien?.get('ceuEntretienEn')?.invalid">{{ 'engin_error_entretien_required' | translate }}</mat-error>
                  </mat-form-field>
                </div>
                <div class="col-4">
                  <mat-form-field>
                    <mat-label>{{ 'ref_field_co2_t' | translate }}</mat-label>
                    <input matInput type="number" formControlName="ceuEntretienCo" required [readonly]="isFormDisable()" />
                    <mat-error *ngIf="formCrls.ceuEntretien?.get('ceuEntretienCo')?.invalid">{{ 'engin_error_entretien_required' | translate }}</mat-error>
                  </mat-form-field>
                </div>
              </div>
            </mat-card>
          </div>
        </div>
      </div>

      <div class="cout-journee skeleton-section" [class]="{ 'disabled-form': isFormDisable() }" *ngIf="isLoadingEnvData">
        <div class="title title-margin-top">
          <h3>{{ 'engin_section_env_cost_day' | translate }}</h3>
          <mat-card class="skeleton-card">
            <div class="row">
              <div class="col-3"><div class="skeleton skeleton-input"></div></div>
              <div class="col-3"><div class="skeleton skeleton-input"></div></div>
            </div>
          </mat-card>
        </div>
      </div>
      <div class="title title-margin-top" *ngIf="!isLoadingEnvData && energyUnavailable">
        <div class="row">
          <div class="col-12 mat-error">
            <mat-icon class="deleted">error</mat-icon>
            {{ 'error_energy_not_available_in_version' | translate }}
          </div>
        </div>
      </div>
      <div class="cout-journee" [class]="{ 'disabled-form': isFormDisable() }" *ngIf="!isLoadingEnvData && !energyUnavailable">
        <div class="title title-margin-top">
          <h3 style="display: flex">
            {{ 'engin_section_env_cost_day' | translate }}
            <span>
              <mat-icon matInput [matTooltip]="'engin_tooltip_calculation_formula' | translate" class="formule-button-info" (click)="viewDownloadCalculCeuEngins()"> help </mat-icon>
            </span>
          </h3>
          <mat-card formGroupName="ceu">
            <div class="row">
              <div class="col-3 disabled-form">
                <mat-form-field>
                  <mat-label>{{ 'ref_field_energy_mj' | translate }}</mat-label>
                  <input matInput type="text" [value]="formCrls.ceu?.get('en')?.value | localizedNumber: '1.0-3'" required readonly />
                </mat-form-field>
                <span *ngIf="formCrls.ceu?.get('en')?.invalid && formSubmitted" class="mat-error">{{ 'ref_error_energy_required' | translate }}</span>
              </div>
              <div class="col-3 disabled-form">
                <mat-form-field>
                  <mat-label>{{ 'ref_field_co2_t' | translate }}</mat-label>
                  <input matInput type="text" [value]="formCrls.ceu?.get('co')?.value | localizedNumber: '1.0-3'" required readonly />
                </mat-form-field>
                <span *ngIf="formCrls.ceu?.get('co')?.invalid && formSubmitted" class="mat-error">{{ 'ref_error_energy_required' | translate }}</span>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <div class="justificatif">
                  <input id="singleFile" #proofUpload type="file" class="inputfile" accept="application/pdf" (change)="uploadProof(currentItem.resourceId, proofUpload.files)" />
                  <button mat-mini-fab color="accent" class="mini-fab" (click)="proofUpload.click()">
                    <mat-icon>add</mat-icon>
                  </button>
                  <label for="singleFile">{{ 'ref_add_proof_pdf' | translate }}</label>
                </div>
                <div *ngIf="currentItem?.fileDescription" class="logo">
                  <a class="img-logo resetPointerEvents" [href]="wsAppPath + currentItem.fileDescription" target="_blank">{{ currentItem.fileName }}</a>
                  <span class="delete_outline">
                    <mat-icon (click)="deleteFile(currentItem)" color="warn">delete_outline</mat-icon>
                  </span>
                </div>
                <div *ngIf="!currentItem?.fileDescription && currentItem?.fileName" class="logo">
                  <span class="img-logo">{{ currentItem.fileName }}</span>
                  <span class="delete_outline">
                    <mat-icon (click)="deleteFile(currentItem)" color="warn">delete_outline</mat-icon>
                  </span>
                </div>
              </div>

              <div class="col">
                <div class="justificatif">
                  <input id="calculFile" #calculUpload type="file" class="inputfile" accept=".pdf, application/pdf" (change)="uploadCalcul(currentItem.resourceId, calculUpload.files)" />
                  <button mat-mini-fab color="accent" class="mini-fab" (click)="calculUpload.click()">
                    <mat-icon>add</mat-icon>
                  </button>
                  <label for="calculFile">{{ 'engin_add_calcul_pdf' | translate }}</label>
                </div>
                <div *ngIf="currentItem?.fileCalculCeuDescription" class="logo">
                  <a class="img-logo resetPointerEvents" [href]="wsAppPath + currentItem.fileCalculCeuDescription" target="_blank">{{ currentItem.fileCalculCeuName }}</a>
                  <span class="delete_outline">
                    <mat-icon (click)="deleteFileCalcul(currentItem)" color="warn">delete_outline</mat-icon>
                  </span>
                </div>
                <div *ngIf="!currentItem?.fileCalculCeuDescription && currentItem?.fileCalculCeuName" class="logo">
                  <span class="img-logo">{{ currentItem.fileCalculCeuName }}</span>
                  <span class="delete_outline">
                    <mat-icon (click)="deleteFileCalcul(currentItem)" color="warn">delete_outline</mat-icon>
                  </span>
                </div>
              </div>
            </div>
          </mat-card>
        </div>
      </div>
      <div class="cout-heure skeleton-section" [class]="{ 'disabled-form': isFormDisable() }" *ngIf="isLoadingEnvData">
        <div class="title title-margin-top">
          <h3>{{ 'engin_section_env_cost_hour' | translate }}</h3>
          <mat-card class="skeleton-card">
            <div class="row">
              <div class="col-3"><div class="skeleton skeleton-input"></div></div>
              <div class="col-3"><div class="skeleton skeleton-input"></div></div>
            </div>
          </mat-card>
        </div>
      </div>
      <div class="cout-heure" [class]="{ 'disabled-form': isFormDisable() }" *ngIf="!isLoadingEnvData && !energyUnavailable">
        <div class="title title-margin-top">
          <h3>{{ 'engin_section_env_cost_hour' | translate }}</h3>
          <mat-card formGroupName="ceuHeure">
            <div class="row">
              <div class="col-3 disabled-form">
                <mat-form-field>
                  <mat-label>{{ 'ref_field_energy_mj' | translate }}</mat-label>
                  <input matInput type="text" [value]="formCrls.ceuHeure?.get('en')?.value | localizedNumber: '1.0-3'" required readonly />
                </mat-form-field>
              </div>
              <div class="col-3 disabled-form">
                <mat-form-field>
                  <mat-label>{{ 'ref_field_co2_t' | translate }}</mat-label>
                  <input matInput type="text" [value]="formCrls.ceuHeure?.get('co')?.value | localizedNumber: '1.0-3'" required readonly />
                </mat-form-field>
              </div>
            </div>
          </mat-card>
        </div>
      </div>
      <div class="ressource" #resourceSection>
        <div class="title title-margin-top">
          <h3>{{ 'ref_section_resource_type' | translate }}</h3>
          <mat-card>
            <div class="row">
              <div class="col-4">
                <mat-form-field>
                  <mat-label>{{ 'ref_field_project_type' | translate }}</mat-label>
                  <mat-select [multiple]="true" formControlName="projectType" [compareWith]="compareProjectTypes" required>
                    <mat-option *ngFor="let p of projectTypes" [value]="p" [disabled]="isFormDisable()">
                      {{ p.displayName | localizedLabel: 'projectType' : p.code }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="col-4">
                <span *ngIf="formCrls.projectType.invalid && (form.controls.projectType.touched || this.formSubmitted)" class="mat-error">{{ form.controls.projectType.errors?.validateProjectType | translate }}</span>
              </div>
            </div>
          </mat-card>
        </div>
      </div>
    </div>
  </form>
</div>
